
import { Select } from "antd"
import Chatbox from "../../components/Classroom/Chatbox/Chatbox";
import { TopBar } from "../../components/CommonComponent/Topbar";
import { useEffect, useState } from "react";
import { useSidebar } from "../../components/common/SidebarContext";

const TestMyAvatare = () => {

  const {selectedAvatare}= useSidebar();
  const [avatares, setAvatares] = useState([]);
  const [pretrainedModels, setPretrainedModels] =useState([]);
  const [chat, setChat] = useState([]);
  const [history,setHistory]=useState(false)
  const [options, setOptions] = useState([]);
  const [selectedPretrainedModel, setSelectedPretrainedModel] =
    useState("Elastic Search");
  const [botName, setBotName] = useState("Zofi");
  const userName = localStorage.getItem("email").split("@")[0];
  const getTrainedBots = async () => {
    let userId = localStorage.getItem("UserId");
    return fetch(
      `${process.env.REACT_APP_API_ROOT}/api/bot/gettrainedbots/?UserId=${userId}`,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    ).then((data) => data.json());
  };

  const getModelsList = async () => {
    return fetch(`${process.env.REACT_APP_API_ROOT}/api/bot/modelslist/`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    }).then((data) => data.json());
  };

  useEffect(() => {
    
   }, [localStorage.getItem("history")]);


  useEffect(() => {
    
    let mounted = true;
    const fetchData = async () => {
      try {
        const trainedBots = await getTrainedBots();
        const modelList = await getModelsList();
        if (mounted) {
          setAvatares(trainedBots.message);
          const botOptions = Array.isArray(trainedBots.message)
            ? trainedBots.message.map((bot) => ({
                label: (
                  <div className="flex items-center gap-2">
                    <span>
                      <img src="/default-bot-icon.svg" />
                    </span>
                    {bot?.BotId?.BotName || "Unnamed Bot"}
                  </div>
                ),
                value: bot?.BotId?.BotId || "",
              }))
            : [{ label: "No Avatar", value: null }];
          setOptions(botOptions);
          setPretrainedModels(modelList.message);
          setSelectedPretrainedModel(modelList.message[0]?.BotId?.BotId);
        }
      } catch (error) {
        // console.error("Error fetching data:", error);

      }
    };
    fetchData();
    return () => {
      mounted = false;
     
    };
  
  }, []);

  useEffect(() => {
  
    const history =JSON.parse(localStorage.getItem("history"));
    const bot =JSON.parse(localStorage.getItem("bot"));
    if(history){
      setHistory(true)
      setBotName(bot?.BotName)
      const formattedChats = bot?.Chat?.map((chat) => ({
        user: chat.Question,
        bot: chat.Answer
      }));
    
      setChat(formattedChats);
    }
  
  }, []);

 

  

  return (
    <>
      <TopBar text={ history ? "Avatare History" + " -  " +botName:"Test" + " - "+ selectedAvatare?.BotName} backArrow={history ? true :false} />
      <div className={`m-6 ${!history ? "flex gap-4" : ""}`}>
  <div className={`${history ? "w-full" : "w-full"} bg-white p-6 rounded-sm`}>
    <Chatbox
      SelectedPretrainedModel={selectedPretrainedModel}
      BotId={selectedAvatare?.BotId}
      BotName={botName}
      userName={userName}
      chat={chat}
      history={history}
      setChat={setChat}
    />
  </div>

  {!history && (
    <>
    </>
    // <div className="w-[30%] px-6">
    //   <div>
    //     <p className="text-xl font-medium">Select your trained Avatare</p>
    //     <p className="mt-1 font-normal">Select one trained Avatare to test this</p>
    //     {selectedAvatare &&<Select
    //       style={{ height: "70px" }}
    //       className="mt-6 w-full focus:outline-none focus:border-[#000]"
    //       placeholder="Select your trained Avatare"
    //       optionFilterProp="label"
    //       value={selectedAvatare}
    //       onChange={handleAvatareChange}
    //       onSearch={handleAvatareChange}
    //       options={options}
    //     />}
    //   </div>
    // </div>
  )}
</div>


      {/* <Button
          variant="contained"
          size="large"
          endIcon={<ArrowRightAltIcon />}
          sx={{
            my: 4,
            ml: "auto",
            width: 250,
            padding: 1,
            backgroundColor: "#295598",
            fontSize: 14,
            fontWeight: "bold",
            color: "#ffffff",
            position: "relative",
            float: "left",
          }}
          onClick={scoreAndRating}
        >
          Scores and Ratings
        </Button> */}
    </>
  );
};

export default TestMyAvatare;
